import { render, staticRenderFns } from "./D3Axis.vue?vue&type=template&id=1b03845e&scoped=true"
import script from "./D3Axis.vue?vue&type=script&lang=js"
export * from "./D3Axis.vue?vue&type=script&lang=js"
import style0 from "./D3Axis.vue?vue&type=style&index=0&id=1b03845e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b03845e",
  null
  
)

export default component.exports